<YCPage title="Blank" query={pageQuery}>
</YCPage>

<script lang="ts">import YCPage from '../components/YCPage.svelte';
export let f7route;
const pageQuery = (f7route === null || f7route === void 0 ? void 0 : f7route.query) || {};
</script>
